import { useState, useEffect } from "react";
import axios from "axios";
import baseurl from "../../../CrudOperations/customURl";

const apiBase = baseurl;

const useReservedFullHooks = () => {
  const [staffList, setStaffList] = useState([]);
  const [formData, setFormData] = useState({
    FullName: "",
    ContactNo: "",
    Department: "",
    Gender: "Male",
    Designation: "Deputy",
    Address: "",
    StaffImage: "",
    CommunityId: "",
    ReservedDeputy: true,
  });
  const [editStaff, setEditStaff] = useState(null);

  // GET reserved staff list
  const fetchStaff = async () => {
    try {
      const res = await axios.get(`${apiBase}/staff/GetReservedStaffList`);
      console.log(res);
      
      setStaffList(res?.data?.Data); // ✅ this was commented out earlier
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  // Add or update staff
  const submitForm = async () => {
    const endpoint = editStaff
      ? `${apiBase}/staff/UpdateReservedStaff`
      : `${apiBase}/staff/AddStaff`;

    try {
      await axios.post(endpoint, formData);
      fetchStaff();     // refresh list after submit
      resetForm();      // clear form
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  const handleEdit = (staff) => {
    setFormData(staff);
    setEditStaff(staff);
  };

  const resetForm = () => {
    setFormData({
      FullName: "",
      ContactNo: "",
      Department: "",
      Gender: "Male",
      Designation: "Deputy",
      Address: "",
      StaffImage: "",
      CommunityId: 2,
      ReservedDeputy: true,
    });
    setEditStaff(null);
  };

  return {
    staffList,
    formData,
    setFormData,
    editStaff,
    setEditStaff,      // ✅ Fix: Add this to avoid "is not a function" error
    handleEdit,
    submitForm,
    resetForm,
    fetchStaff,
  };
};

export default useReservedFullHooks;
